import React, { useState, useEffect } from "react";
import "../styles/Testimonials.css";

const testimonialsContext = require.context(
  "../content/testimonials",
  false,
  /\.json$/
);

const Testimonials = () => {
  const [testimonials, setTestimonials] = useState([]);

  useEffect(() => {
    try {
      const loadedTestimonials = testimonialsContext
        .keys()
        .map((key) => testimonialsContext(key));
      setTestimonials(loadedTestimonials);
    } catch (e) {
      console.error("Error loading testimonials:", e);
      setTestimonials([]);
    }
  }, []);

  if (testimonials.length === 0) return null;

  return (
    <section className="testimonials-section">
      <div className="testimonials-container">
        <h3 className="testimonials-title">Kaj pravijo naše stranke</h3>
        <div className="testimonials-grid">
          {testimonials.map((testimonial) => (
            <div key={testimonial.id} className="testimonial-card card fade-in">
              <div className="testimonial-rating">
                {[...Array(testimonial.stars || 5)].map((_, i) => (
                  <span key={i} className="star">
                    ★
                  </span>
                ))}
              </div>
              <p className="testimonial-text">"{testimonial.text}"</p>
              <p className="testimonial-author">— {testimonial.name}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
